<template>
  <div class="animated fadeIn mt-3">
    <div class="clearfix dashboard__main-menu">
      <h5 class="pull-left">Dashboard</h5>
      <div class="pull-right">
        <div style="display: inline-block" id="dr__container">
          <span id="dr__info" class="fa fa-info-circle"></span>
          <ui-multiselect
            @select-option="onChangePresetRangedate"
            :class="'dr__all-widget'"
            :selectLabel="'Change Date Range'"
            :label="'name'"
            :options="presetsDaterange"></ui-multiselect>
        </div>
        <b-button title="Create New Widget" @click="showModalWidget=true" variant="success" size="sm" class="my-2 my-sm-0">
          <i class="fa fa-plus"></i> New Widget
        </b-button>
      </div>
    </div>
    <widget
      @on-updated-layout="onUpdated"
      @on-edit-widget="onEditWidget"
      :widgetItems="items"
      :breakpoints="breakpoints"
      :cols="cols"></widget>
    <CreateEdit
      @on-submited="onSubmitedForm"
      @on-show="onUpdateStateModal"
      :editWidget="editWidget"
      :widgetItems="items"
      :showModal="showModalWidget" />
    <b-popover
      triggers="hover focus"
      :placement="'lefttop'"
      :target="'dr__info'">
        <template slot="title">Change Date Range</template>
        If you change the date range,
        it will affect to all widgets,
        will be <strong> saved </strong> and
        <strong>can't be <span class="text-danger">undone</span></strong>.
    </b-popover>
  </div>
</template>

<script>
import dashboardMixin from '@/mixins/dashboard';
import UiMultiselect from '@/components/UiMultiselect';
import { isEmpty, cloneDeep, get, debounce } from 'lodash';
import Widget from './Widget';
import CreateEdit from './CreateEdit';

export default {
  name: 'dashboard',
  mixins: [dashboardMixin],
  components: {
    Widget,
    UiMultiselect,
    CreateEdit,
  },
  data() {
    return {
      items: [],
      showModalWidget: false,
      editWidget: null,
      breakpoints: {
        lg: 996,
        md: 900,
        sm: 768,
        xs: 300,
        xxs: 0,
      },
      cols: {
        lg: 12,
        md: 12,
        sm: 10,
        xs: 6,
        xxs: 4,
      },
      widgets: [],
    };
  },
  created() {
    this.$store.commit('SET_BREADCRUMB_ITEMS', [
      { to: '', name: 'Home' },
      { to: 'dashboard', name: 'Dashboard' },
    ]);

    window.onresize = debounce(() => {
      this.loadUserPreferences();
    }, 1e3);

    this.loadUserPreferences();
  },
  watch: {
    widgets(wg) {
      if (!isEmpty(wg)) {
        const wgParsed = this.parsePreference(wg, 'toJSON');
        this.items = this.processDateItems(wgParsed);
        this.items = this.checkResponsiveLayout();
      } else if (isEmpty(wg) && isEmpty(this.items)) {
        this.items = this.processDateItems(this.defaultWidgets);
      }
    },
  },
  methods: {
    onSubmitedForm() {
      this.loadUserPreferences();
    },
    loadUserPreferences() {
      this.$store.dispatch('dashboard/LOAD_USER_PREFERENCES').then((data) => {
        const hasDashboardProperty = Object.prototype.hasOwnProperty.call(data, 'dashboard');
        const widgets = hasDashboardProperty ? data.dashboard : [];
        this.widgets = widgets;
      });
    },
    saveLayout(settings) {
      if (settings === '[]') return Promise.resolve();
      return this.$store.dispatch('dashboard/UPDATE_USER_PREFERENCES', {
        dashboard: settings,
      });
    },
    processDateItems(items) {
      const newItem = items
        .filter(item => (item.name !== 'completion_items'))
        .map((item) => {
          const hasDaterange = Object.prototype.hasOwnProperty.call(item, 'date_range');
          const isCustom = item.date_range === 'custom';
          if (hasDaterange && !isCustom) {
            const { start_date, end_date } = this.updateRange(item.date_range);
            item.start_date = start_date;
            item.end_date = end_date;
          }
          return item;
        });

      return newItem;
    },
    onEditWidget(wg) {
      this.showModalWidget = true;
      this.editWidget = wg;
    },
    onUpdated(newLayouts) {
      let parsedJSONLayout = newLayouts.map((l) => {
        delete l.moved;
        return l;
      });
      parsedJSONLayout = this.parsePreference(newLayouts, 'toString');

      return this.saveLayout(parsedJSONLayout);
    },
    checkResponsiveLayout() {
      const widthLayout = get(document.getElementsByClassName('dashboard__main-menu'), '0.clientWidth') || 0;
      const isMobile = widthLayout < this.breakpoints.md;

      if (!isMobile) return this.items;

      let totalHeight = 0;
      const newItems = this.items
        .sort((a, b) => (a.y > b.y ? 1 : a.y < b.y ? -1 : 0)) // eslint-disable-line
        .map((dt, i) => {
          if (i > 0) {
            const beforeItem = this.items[i - 1];
            totalHeight += beforeItem.h;
            dt.y_m = totalHeight;
          } else {
            dt.y_m = dt.y;
          }
          return dt;
        });
      return newItems;
    },
    onChangePresetRangedate(range) {
      if (!isEmpty(range)) {
        const newRange = range.value;
        const updatedRange = this.items.map((item) => {
          const hasRangedate = Object.prototype.hasOwnProperty.call(item, 'date_range');
          if (hasRangedate) {
            const { start_date, end_date } = this.updateRange(newRange);
            item.date_range = newRange;
            item.start_date = start_date;
            item.end_date = end_date;
          }
          return item;
        });

        this.items = cloneDeep(updatedRange);
        this.onUpdated(this.items);
      }
    },
    onUpdateStateModal(val) {
      this.showModalWidget = val;
      if (val === false) {
        this.editWidget = null;
      }
    },
  },
};
</script>
<style lang="sass">
.dashboard__main-menu
  background-color: #f0f3f5;
  padding: 10px;

.dashboard__main-menu
  h5
    margin-bottom: 0px;
    margin-top: 8px;
    font-weight: bold;

#dr__container
  position: relative;

#dr__info
  position: absolute;
  bottom: 11px;
  left: -10px;
  cursor: default;
  color: #1089e8;

.dr__all-widget
  display: inline-block;
</style>




// WEBPACK FOOTER //
// src/views/pages/dashboard/Index.vue